import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import { Module } from "@/store/enums.ts";
import AutoInstruction from "./AutoInstruction";

@Component
export default class TalkToMeJrIntro extends Vue {
  uiDesc = {
    color: "warning"
  };
  private _enableNext!: boolean;
  private audioLoc =
    "/res/protected/t2mejr_instructions/ttmj_intro_autoplay.mp3";

  constructor() {
    super();
    this._enableNext = false;
  }

  created() {
    this._enableNext = false;
    this.$store.dispatch("setClip", {
      path: this.audioLoc,
      callbackFunction: () => {
        this._enableNext = true;
        this.$forceUpdate();
      }
    });
    this.$forceUpdate();
  }

  beforeDestroy() {
    this.$store.dispatch("removeClip", this.audioLoc);
  }

  render(h: CreateElement) {
    return (
      <Card title="Talk2MeJr - Introduction" mod={Module.TTMJ}>
        <div slot="mainContent">
          <p class="font-weight-bold subtitle-1">1. What is Talk2MeJr.?</p>
          <p class="subtitle-2">
            Talk2Me Jr. is a 21st century language and assessment tool to
            support student learning and language.
          </p>

          <p class="font-weight-bold subtitle-1">2. What does it assess?</p>
          <p class="subtitle-2">
            It collects and looks at students’ linguistic and cognitive markers
            that may show reading and learning potential among students.
          </p>

          <p class="font-weight-bold subtitle-1">
            3. What are linguistic and cognitive markers?
          </p>
          <p class="subtitle-2">
            Good readers can read a text fluently, decode words based on sounds,
            understand a long oral story, tell a coherent story from pictures,
            and understand and use a wide range of vocabulary. Learning involves
            good memory and reasoning to recall information and solve difficult
            problems. Poor attention and memory are highly connected to reading
            and learning difficulties. Talk2Me Jr. is designed to identify such
            important markers that determine the nature for reading
            difficulties.
          </p>
        </div>

        <div slot="actions">
          <v-btn
            color="warning"
            to="/talk2mejr/setup"
            disabled={!this._enableNext}
          >
            Next
          </v-btn>
        </div>
      </Card>
    );
  }
}

const component = TalkToMeJrIntro;
